import React from 'react';
import FormModalComponent from '../components/FormModal/FormModal';

const FormModal = (props) => <FormModalComponent {...props} />;

export default FormModal;